var Deferred = /** @class */ (function () {
    function Deferred() {
        this.promise = new Promise(function (resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;
        }.bind(this));
        Object.freeze(this);
    }
    return Deferred;
}());
export { Deferred };
//# sourceMappingURL=Deferred.js.map